import { render, staticRenderFns } from "./DetailTomanTransaction.vue?vue&type=template&id=085aff07&scoped=true"
import script from "./DetailTomanTransaction.vue?vue&type=script&lang=js"
export * from "./DetailTomanTransaction.vue?vue&type=script&lang=js"
import style0 from "./DetailTomanTransaction.vue?vue&type=style&index=0&id=085aff07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085aff07",
  null
  
)

export default component.exports